"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineViews = exports.routes = void 0;
const home_page_1 = require("../main/home-page");
const install_page_1 = require("../install/install-page");
const InstallConstants = require("../install/constants");
const SpectrumConstants = require("../spectrum/constants");
const spectrum_analyzer_1 = require("../spectrum/spectrum-analyzer");
exports.routes = [
    {
        path: '/web',
        tag: 'home-page',
        pathParamNames: [],
        queryParamNames: [],
    },
    {
        path: `/web/${InstallConstants.routerPathGroup}`,
        tag: 'install-page',
        pathParamNames: [],
        queryParamNames: [],
    },
    {
        path: `/web/${SpectrumConstants.routerPathGroup}/analyzer`,
        tag: 'spectrum-analyzer',
        pathParamNames: [],
        queryParamNames: [],
    },
];
const defineViews = () => {
    (0, home_page_1.defineHomePage)('home-page');
    (0, install_page_1.defineInstallPage)('install-page');
    (0, spectrum_analyzer_1.defineSpectrumAnalyzer)('spectrum-analyzer');
};
exports.defineViews = defineViews;
